//* ------------------------------------*\
//    $CLASS NAMES - for class names
//      not CSS selectors
//* ------------------------------------*/

const CLASS_NAMES = {
  ABOVE_BOTTOM: 'above-bottom',
  ABOVE_HALFWAY: 'above-halfway',
  ABOVE_VIEWPORT: 'above-viewport',
  ACCORDION_BODY_OPEN: 'footer__accordion-body--open',
  ACTIVE: 'active',
  BELOW_BOTTOM: 'below-bottom',
  BELOW_HALFWAY: 'below-halfway',
  BELOW_VIEWPORT: 'below-viewport',
  BLINK: 'blink',
  ERROR: 'error',
  CLOSED: 'closed',
  FADE: 'fade',
  FILTER_SELECTED: 'filter-selected',
  FIRST_BATCH: 'first-batch',
  FIXED: 'fixed',
  FILTERED: 'filtered',
  FINANCIALS_BLOCK_HIDDEN: 'financials__repeater-block--hidden',
  FINANCIALS_SHOW_MORE_HIDDEN: 'financials__show-more--hidden',
  HIDING: 'hiding',
  HAS_ERROR: 'has-error',
  HAS_VALUE: 'has-value',
  HIDDEN: 'hidden',
  HOVER: 'hover',
  IMAGE_CAPTION_VARIABLE_WIDTH: 'image-caption--variable-width',
  IN_VIEWPORT: 'in-viewport',
  INPUT_ERROR: 'input-error',
  IS_ANIMATABLE: 'is-animatable',
  IS_CONTENT_VISIBLE: 'is-content-visible',
  IS_CURSOR_ACTIVE: 'is-cursor-active',
  IS_EXPANDED: 'is-expanded',
  IS_INSIDE_CONTENT: 'is-inside-content',
  IS_OPEN: 'is-open',
  IS_PLAYING: 'is-playing',
  IS_REVEALED: 'is-revealed',
  LISTING_FILTERS: 'listing-filters',
  LOADING: 'loading',
  MENU_OPEN: 'menu-open',
  MINI: 'mini',
  MOBILE_MENU_OVERLAY: 'mobile-menu-overlay',
  OPEN: 'open',
  OPENED: 'opened',
  SCROLLED: 'scrolled',
  SEARCHING: 'searching',
  SELECTED: 'selected',
  SELECT_OPEN: 'select-open',
  SHOW: 'show',
  SUB_MENU: 'sub-menu',
  SUCCESS: 'success',
  VISUALLY_HIDDEN: 'visually-hidden',
  VIDEOS_AND_TEXT_SCROLL_LOCK: 'vt-scroll-lock'
};

export default CLASS_NAMES;
